import type { ReactElement, SVGAttributes } from "react";

const SIZE_MAP = {
  small: { scale: 0.75 },
  default: { scale: 1 },
  large: { scale: 1.25 },
};

type SVGProps = Omit<SVGAttributes<SVGElement>, "height" | "width">;

export interface IllustrationProps extends SVGProps {
  size?: keyof typeof SIZE_MAP;
}

export type Illustration = (props: IllustrationProps) => ReactElement;

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function illustrationProps(
  { size = "default", ...rest }: IllustrationProps,
  { width }: { width: number },
) {
  const { scale } = SIZE_MAP[size];

  return {
    width: scale * width,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": true,
    ...rest,
  };
}
